import { Link,useRouterState } from '@tanstack/react-router';
import { MenuProps } from 'rc-menu';
import React, { useState } from 'react'
import {
  ControlOutlined,
  DesktopOutlined,
  ScheduleOutlined,
  SettingOutlined,
  LogoutOutlined,
  DashboardOutlined,
  YoutubeOutlined,
  ToolOutlined,
  VideoCameraOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { Menu, Modal } from 'antd';


type MenuItem = Required<MenuProps>["items"][number];
function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

const SidebarItems = () => {
    const [collapsed, setCollapsed] = useState(false);
    const location = useRouterState()?.location?.pathname.split("/").filter(Boolean)[0] || "";

    const handleOk = () => {
  localStorage.removeItem("AUTH_TOKEN");
  window.location.reload();
};

    const items: any /*MenuItem[]*/ = [
  getItem(
    <Link to="/dashboard" >
      Dashboard
    </Link>,
    "dashboard",
    <DashboardOutlined />
  ),
  getItem(
    <Link to="/schedules" from="/">
      Schedules
    </Link>,
    "schedules",
    <ScheduleOutlined />
  ),
  getItem(
    <Link to="/list" from="/">
      History
    </Link>,
    "list",
    <DesktopOutlined />
  ),
  getItem(
    <Link to="/youtube" from="/">
      Youtube
    </Link>,
    "youtube",
    <YoutubeOutlined />
  ),
  getItem(
    <Link to="/config" from="/">
      Configuration
    </Link>,
    "config",
    <ControlOutlined />
  ),
  getItem(
    <Link to="/tools" from="/">
      Utility
    </Link>,
    "tools",
    <ToolOutlined />
  ),
  getItem(
    <Link to="/settings" from="/">
      Settings
    </Link>,
    "settings",
    <SettingOutlined />
  ),
  // getItem(
  //   <Link to="/queue" from="/">
  //     Api JObs
  //   </Link>,
  //   "queue",
  //   <SettingOutlined />
  // ),
  // getItem(
  //   <Link to="/editor" from="/">
  //     Editor
  //   </Link>,
  //   "editor",
  //   <SettingOutlined />
  // ),
   getItem(
    <Link to="/player" from="/">
      HLS Player
    </Link>,
    "player",
    <VideoCameraOutlined/>
  ),
  getItem(
    <Link to="/report" from="/">
      Report
    </Link>,
    "report",
    <BarChartOutlined/>
  ),
  getItem(
    <p
      onClick={() => {
        Modal.confirm({
          title: "Confirm",
          content: "Are You Sure You Want to Logout?",
          okText: "Yes",
          cancelText: "No",
          onOk: handleOk,
        });
      }}
    >
      Logout
    </p>,
    "6",
    <LogoutOutlined />
  ),
];
  return (
    <>
    <>
        {collapsed ? (
          <img
            height={40}
            alt="KGS Studio"
            src={
              "https://kgs-v2.akamaized.net/kgs/kgs-do/uploads/hbC0ocuRD41Btvm2JRqK9gkjCxMPkH2YIXShLG5Q.png"
            }
          />
        ) : (
          <>
            <img
              height="auto"
              src="/kgs-studio.png"
              alt="KGS Studio"
              width="80%"
            />
          </>
        )}
      </>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location]}
        defaultSelectedKeys={["1"]}
        items={items}
        style={{ background: "#1D1F5D" }}
      />
    </>
  )
}

export default SidebarItems